var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "go-to-back__Type=Go-to-back, Style=Outline, Size=24",
    className: "go-to-back__Type=Go-to-back, go-to-back__Style=Outline, go-to-back__Size=24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "go-to-back__Vector 140 (Stroke)",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 11.959a.969.969 0 0 0-.969-.97H8.307l1.89-1.889a.969.969 0 1 0-1.37-1.37l-3.543 3.544a.969.969 0 0 0-.008 1.362l3.542 3.627a.969.969 0 1 0 1.386-1.354L8.27 12.928h9.762a.969.969 0 0 0 .969-.97Z",
    className: "go-to-back__Vector go-to-back__140 go-to-back__(Stroke)",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.1d816561a72c0de20f9592d6c11e6473.svg";
export { ForwardRef as ReactComponent };